<template>
  <div>
    <a-layout id="layout">
      <layout-nav />
      <layout-main />
    </a-layout>
  </div>
</template>

<script>
import LayoutMain from './childComps/LayoutMain.vue'
import LayoutNav from './childComps/LayoutNav.vue'
export default {
  components: {
    LayoutNav,
    LayoutMain

  },
  data() {
    return {

    }
  },
  methods: {
    /**
    * 逻辑区
    */


    /**
    * 接口区
    */


  }
}
</script>

<style lang='scss' scoped>
  #layout {
    width: 100vw;
    height: 100vh;
  }
</style>
